import { prefixerD } from './common'

export const ROUTE_DASHBOARD_MAQUINARIA = prefixerD('maquinaria')

export const ROUTE_DASHBOARD_ORDEN_TRABAJO = prefixerD('ordenTrabajo')

export const ROUTE_DASHBOARD_POR_MANTENIMIENTO = prefixerD('porMantenimiento')
